export const XPO_FACET_FILTER_ERROR_CONSTANTS = {
  missingFilterId: '[ngxltl-core] filterID property not defined',
};
